import { FunctionComponent } from 'react';
import { CustomsInformation } from '../../../../sharedComponents/common.types';
import { NoValue } from '../../../../sharedComponents/NoValue';
import { OptionalFormattedDate } from '../../../../sharedComponents/OptionalFormattedDate';
import { FormattedMessage } from 'react-intl';

type CustomsInformationTableProps = {
    customsInformation?: CustomsInformation | undefined;
};

export const CustomsInformationTable: FunctionComponent<CustomsInformationTableProps> = ({ customsInformation }) => {
    return (
        <table className="table table-row-first-border-none table-row-last-border-none table-layout-fixed table-column-overflow-hidden">
            <tbody>
                <tr>
                    <td>
                        <FormattedMessage id="outboundOrderBook.common.sidebar.details.vehicle.customsInformation.referenceNumber" />
                    </td>
                    <td>{customsInformation?.customsReferenceNumber ?? <NoValue />}</td>
                </tr>
                <tr>
                    <td>
                        <FormattedMessage id="outboundOrderBook.common.sidebar.details.vehicle.customsInformation.issuedAt" />
                    </td>
                    <td>
                        <OptionalFormattedDate date={customsInformation?.customsReferenceNumberIssuedAt} />
                    </td>
                </tr>
            </tbody>
        </table>
    );
};
